<template>
    <div class="MemolifeLogo">
        <div v-if="showHeart" class="heart" />
        <div class="text" />
    </div>
</template>

<script>
export default {
    data() {
        return {
            showHeart: true
        };
    },

    watch: {
        '$route.name': {
            handler: function () {
                this.setShowHeartBoolean();
            },
            deep: true,
            immediate: true
        }
    },

    created() {
        this.setShowHeartBoolean();

        window.addEventListener('resize', this.setShowHeartBoolean);
    },

    beforeDestroy() {
        window.removeEventListener('resize');
    },

    methods: {
        setShowHeartBoolean() {
            const isMobile = screen.width < 530;
            const isNotHomePage = this.$route.name !== 'DashboardHomeView';

            if (isMobile && isNotHomePage) {
                this.showHeart = false;
            } else {
                this.showHeart = true;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.MemolifeLogo {
    display: flex;
    align-items: center;
}
.heart {
    $height: 1.8em;
    height: $height;
    width: $height * 1.2;
    margin-right: 0.5em;
    background-image: url('./memolife-heart.svg');
    background-size: contain;
    background-repeat: no-repeat;
}
.text {
    $height: 1em;
    height: $height;
    width: $height * 6.25;
    background-image: url('./memolife-white.svg');
    background-size: contain;
    background-repeat: no-repeat;
    @media (max-width: 530px) {
        display: none;
    }
}
</style>
